import React, { useCallback, useEffect, useRef, useState } from 'react'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import BodyText from 'LuxKit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import Image from 'components/Common/Image'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'

interface Props {
  title: string
  description: string
  primaryActionText: string
  onClickAction: () => void
  onClose: () => void
}

const DEFAULT_LOADING_TIME_IN_MS = 3000

function WhiteLabelAppPromoModal({ title, description, primaryActionText, onClickAction, onClose }: Props) {
  const [isLoading, setIsLoading] = useState(false)
  const modal = useModalElementContext()
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const timeout = timeoutRef.current
    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [])

  const close = useCallback(() => {
    onClose()
    modal.resolve()
  }, [modal, onClose])

  const handlePrimaryAction = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    setIsLoading(true)
    onClickAction()

    timeoutRef.current = setTimeout(() => {
      setIsLoading(false)
      modal.resolve()
    }, DEFAULT_LOADING_TIME_IN_MS)
  }, [onClickAction, modal])

  return <ModalBase>
    <ModalHeader title="" isOverlay />
    <ModalBody>
      <Image image={{ id: 'dfez7lb6hpf8b3mgjjla' }} quality="best" dpr={3} width={250} fit="center" />
      <ModalContent>
        <Group direction="vertical" gap={12}>
          <Heading variant="heading3">{title}</Heading>
          <BodyText variant="large">{description}</BodyText>
        </Group>
      </ModalContent>
    </ModalBody>
    <ModalFooter
      primaryActionProps={{
        children: isLoading ? 'Opening Grill\'d...' : primaryActionText,
        disabled: isLoading,
        onClick: handlePrimaryAction,
      }}
      secondaryActionProps={{
        children: 'Don\'t show it again',
        disabled: isLoading,
        onClick: close,
      }}
    />
  </ModalBase>
}

export default WhiteLabelAppPromoModal
